import { Badge, Box, Typography } from "@mui/material";
import React from "react";

export interface TituloPaginaProps {
  numeroRegistros: number;
  titulo: string;
  color?: string;
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2"
    | "caption"
    | "button"
    | "overline"
    | undefined;
}

const TituloPagina = ({
  numeroRegistros,
  titulo,
  color,
  variant,
}: TituloPaginaProps) => {
  if (numeroRegistros === 0) {
    return (
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          variant={variant || "h4"}
          sx={{
            fontWeight: "bold",
            textAlign: "left",
            width: "100%",
            paddingRight: 2,
            color
          }}
        >
          {titulo}
        </Typography>
      </Box>
    );
  }
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Badge color="primary" badgeContent={numeroRegistros} max={999999}>
        <Typography
          variant={variant || "h4"}
          sx={{
            fontWeight: "bold",
            textAlign: "left",
            width: "100%",
            paddingRight: 2,
            color
          }}
        >
          {titulo}
        </Typography>
      </Badge>
    </Box>
  );
};

export default TituloPagina;
